import React, { useState, useEffect } from "react";
import { WarningCircle } from "@phosphor-icons/react";

const GuidelinesInput = ({ value, onChange, error, onInputChange }) => {
    const [inputValue, setInputValue] = useState("");

    useEffect(() => {
        setInputValue(""); // Clear the input value on guidelines change
    }, [value]);

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            addGuideline();
        }
    };

    const handleChange = (event) => {
        const newValue = event.target.value;
        setInputValue(newValue);
        onInputChange(newValue);
    };

    const addGuideline = () => {
        const trimmedValue = inputValue.trim();
        if (trimmedValue) {
            onChange([...value, trimmedValue]);
            setInputValue("");
            onInputChange(""); // Clear the input in parent component
        }
    };

    return (
        <div className="h-[200px] p-3  space-y-2 w-full border-b-[1.5px]">
            <label className="block text-sm font-medium text-gray-700">
                Guidelines
            </label>
            <textarea
                value={inputValue}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                rows={4}
                placeholder="Enter a guideline and press Enter to add"
                className={`w-[95%] p-2 border-[1.5px] border-gray-300 rounded-md focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50`}
            />
            {error && (
                <div className="flex items-center mt-1 text-[#ff7378] text-xs">
                    <WarningCircle className="w-4 h-4 mr-1" />
                    <span>{error}</span>
                </div>
            )}
        </div>
    );
};

export default GuidelinesInput;
